import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import axios from "../../api/axios";

const RequisitionGraph = () => {
  const [chartData, setChartData] = useState({
    series: [
      {
        name: "Requisition",
        data: [],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
      },
    },
  });

  useEffect(() => {
    axios
      .get("get-all-requisition")
      .then((response) => {
        // Make sure response.data is actually an array
        const requisitionData = Array.isArray(response.data)
          ? response.data
          : [];
        const categories = requisitionData.map((item) => item.product_name);
        const seriesData = requisitionData.map((item) => item.quantity);

        setChartData((prevState) => ({
          ...prevState,
          series: [
            {
              name: "Requisition",
              data: seriesData,
            },
          ],
          options: {
            ...prevState.options,
            xaxis: {
              categories: categories,
            },
          },
        }));
      })
      .catch((error) => {
        console.error("Error fetching requisition data:", error);
      });
  }, []);

  // Optional: simple conditional rendering to avoid edge cases
  if (
    chartData.series.length === 0 ||
    !chartData.series[0].data ||
    chartData.series[0].data.length === 0
  ) {
    return <div>Loading...</div>;
  }

  return (
    <div className="card mb-5 border-0 shadow">
      <div className="card-header py-3 text-center">
        <b>Requisition Graph</b>
      </div>
      <div className="card-body">
        <div id="chart">
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={350}
          />
        </div>
      </div>
    </div>
  );
};

export default RequisitionGraph;
